import useSessionManager from "./useSessionManager";

export default function SessionManagerWrapper({ children }: { children: React.ReactNode }) {
  useSessionManager(); // now router exists ✅
  return <>{children}</>;
}